import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { BrowserRouter } from 'react-router-dom';
import App from './Pages/App';
import './index.css';
import ContextProvider from './Pages/ContextProvider';
import { Server } from '../src/Utils';

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: Server.ENV.name,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

const root = ReactDOM.createRoot(document.getElementById('root'));

if (!Server.isValidTenant) {
  root.render(
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', fontFamily: 'sans-serif', textAlign: 'center' }}>
      <div>
        <h2>Invalid URL</h2>
        <p>Please access the portal using your organisation's URL.</p>
        <p style={{ color: '#888' }}>e.g. <code>yourorg.portal.visilant.org</code></p>
      </div>
    </div>
  );
} else {
  root.render(
    <Sentry.ErrorBoundary fallback={<p>An error occurred. Please refresh the page.</p>}>
      <React.StrictMode>
        <BrowserRouter>
          <ContextProvider>
            <App />
          </ContextProvider>
        </BrowserRouter>
      </React.StrictMode>
    </Sentry.ErrorBoundary>
  );
}
